export default "__VITE_ASSET__Dmssesic__"